import cmsSettings from '../cmsSettings'
import giftCardCategory from '../giftCardCategory'
import giftCardFaceplate from '../giftCardFaceplate'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
  sectionBackground,
  categories[]{
    category->{ ${giftCardCategory.fields} },
    "cards": cards[]->{
      ${giftCardFaceplate.fields},
      enabledRegions
    }
  }
`

export const fragment = (name = 'giftCardGrid') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
